export default "__VITE_ASSET__C201Gftk__"